export default "__VITE_ASSET__DUHeSve7__"